import { pluralizeWithCount } from "@common/helpers/string";

export interface BulkUnmatchInvoicesCounts {
    unmatchedCount: number;
    failedCount: number;
    transferMatchSkippedCount: number;
}

/**
 * Toast copy for a bulk invoice unmatch. Counts are transactions, since one
 * transaction can pay several invoices: "Unmatched invoices on 3
 * transactions", with ", 2 failed" and ", 1 skipped with a transfer match"
 * appended for partial results. `null` when nothing was unmatched or skipped
 * for a transfer match, or when something also failed, so the caller shows
 * the failure message instead.
 */
export function bulkUnmatchInvoicesMessage({
    unmatchedCount,
    failedCount,
    transferMatchSkippedCount,
}: BulkUnmatchInvoicesCounts): string | null {
    if (unmatchedCount === 0) {
        if (transferMatchSkippedCount === 0 || failedCount > 0) {
            return null;
        }
        return `Skipped ${pluralizeWithCount("transaction", transferMatchSkippedCount)} with a transfer match`;
    }
    const parts = [
        `Unmatched invoices on ${pluralizeWithCount("transaction", unmatchedCount)}`,
    ];
    if (failedCount > 0) {
        parts.push(`${failedCount} failed`);
    }
    if (transferMatchSkippedCount > 0) {
        parts.push(
            `${transferMatchSkippedCount} skipped with a transfer match`,
        );
    }
    return parts.join(", ");
}
